import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-drop-notail",
  "use": "icon-arrow-drop-notail-usage",
  "viewBox": "0 0 10 9",
  "content": "<symbol viewBox=\"0 0 10 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-drop-notail\">\n<path d=\"M4.836 8.364L0 0H9.66L4.836 8.364Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/arrow-drop-notail.svg
// module id = bH3v
// module chunks = 258